import { call, put, delay } from "redux-saga/effects";
import { push } from "connected-react-router";

import {
  addCommitError,
  receivedResponseOnCommit,
  loadProjectByCommitError,
  receivedProjectByCommit,
  getMyRepositoryError,
  receivedMyRepository,
  getProjectByRepositoryError,
  receivedProjectByRepository,
  getRepositoryError,
  receivedRepository,
} from "../actions/ide";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../actions/notification";

import * as ideApi from '../api/ide';

const successAddedCommit = "All set! Your project has been saved.";
const errorAddedCommit = "Oops! We couldn't save your project. Please try again or check your connection.";

const successLoadedProject = "All set! Your project is back to the old version.";
const errorLoadedProject = "Uh-oh! Something went wrong—try again.";

export function* addCommit({ payload }) {
  try {
    const { data } = yield call(ideApi.addCommit, payload);
    const { repository, commit } = data;

    if (!repository?.id || !commit?.id) {
      yield put(showErrorMessage(errorAddedCommit));
      yield put(addCommitError());
      return;
    }

    const maxAttempts = 15;
    const interval = 2000;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const { data: isCommitSaved } = yield call(
        ideApi.getIsCommitSaved,
        repository.id,
        commit.id
      );

      if (!!isCommitSaved) {
        yield put(receivedResponseOnCommit({ repository, commit }));
        yield put(showSuccessMessage(successAddedCommit));
        return;
      }
      yield delay(interval);
    }

    yield put(showErrorMessage(errorAddedCommit));
    yield put(addCommitError());
  } catch (e) {
    yield put(showErrorMessage(errorAddedCommit));
    yield put(addCommitError());
    console.log(e);
  }
}

export function* getProjectByCommit({ payload }) {
  try {
    const { repositoryId, commitId, initialLoad } = payload;
    const { data } = yield call(ideApi.getProjectByCommit, repositoryId, commitId);

    if (!data) {
      yield put(showErrorMessage(errorLoadedProject));
      yield put(loadProjectByCommitError());
    } else {
      yield put(receivedProjectByCommit({ commitId, project: data }));
      if (!initialLoad) yield put(showSuccessMessage(successLoadedProject));
    }

  } catch (e) {
    yield put(showErrorMessage(errorLoadedProject));
    yield put(loadProjectByCommitError());
    console.log(e);
  }
}

export function* getMyRepository({ payload }) {
  try {
    const { data } = yield call(ideApi.getMyRepository, payload);

    if (data?.error) {
      yield put(getMyRepositoryError());
      yield put(push('/home'));
    } else {
      yield put(receivedMyRepository({ repository: data }));
    }

  } catch (e) {
    yield put(getMyRepositoryError());
    yield put(push('/home'));
    console.log(e);
  }
}

export function* getProjectByRepository({ payload }) {
  try {
    const { data } = yield call(ideApi.getProjectByRepository, payload);

    if (!data) {
      yield put(showErrorMessage(errorLoadedProject));
      yield put(getProjectByRepositoryError());
    } else {
      yield put(receivedProjectByRepository({ project: data }));
    }

  } catch (e) {
    yield put(showErrorMessage(errorLoadedProject));
    yield put(getProjectByRepositoryError());
    console.log(e);
  }
}

export function* getRepository({ payload }) {
  try {
    const { data } = yield call(ideApi.getRepository, payload);

    if (data?.error) {
      yield put(getRepositoryError());
    } else {
      yield put(receivedRepository({ repository: data }));
    }

  } catch (e) {
    yield put(getRepositoryError());
    console.log(e);
  }
}
